// Textos do boost/turbo da página de venda alternativa. Mesmas regras do site
// (single-page/utils subcampaignAwarenessText + components/SubcampaignHint),
// reescritas sem moment para o pack da página continuar leve — o teste
// __tests__/boost.test.js compara as duas saídas para não divergirem.

const pad = (n) => String(n).padStart(2, '0');

function drawTimeText(drawTime) {
  const d = new Date(drawTime);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} às ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function awarenessText(sub, boost = null) {
  if (!sub) return '';
  const boostedRatio = boost ? boost.boosted_ratio : null;
  const multiplier = boost ? boost.multiplier : null;
  let text;
  if (sub.prize_description) {
    text = `Comprando agora você também concorre a ${sub.prize_description}`;
    if (sub.draw_time) text += `, sorteio ${drawTimeText(sub.draw_time)}`;
    text += '.';
  } else {
    text = 'Comprando agora você também concorre a prêmios instantâneos';
    if (sub.instant_prize_tickets && sub.instant_prize_tickets > 0) {
      const many = sub.instant_prize_tickets > 1;
      text += ` (${sub.instant_prize_tickets} prêmio${many ? 's' : ''} disponíve${many ? 'is' : 'l'})`;
    }
    text += '.';
  }
  const boosted = boostedRatio && sub.ratio > 1 && boostedRatio < sub.ratio;
  if (multiplier > 1) {
    const before = sub.ratio > 1
      ? `antes uma chance a cada ${sub.ratio} bilhetes`
      : 'antes uma chance por bilhete';
    text += ` Agora cada bilhete comprado vale ${multiplier} chances de concorrer (${before}).`;
  } else if (boosted && boostedRatio === 1) {
    text += ` Agora todo bilhete vale uma chance de concorrer (antes a cada ${sub.ratio} bilhetes).`;
  } else if (boosted) {
    text += ` A cada ${boostedRatio} bilhetes (antes ${sub.ratio}), você ganha uma chance de concorrer.`;
  } else if (sub.ratio > 1) {
    text += ` A cada ${sub.ratio} bilhetes, você ganha uma chance de concorrer.`;
  }
  return text;
}

export const isTurbo = (boost) => Boolean(boost) && boost.multiplier > 1;

export function boostTitle(boost) {
  if (boost.title) return boost.title;
  return isTurbo(boost) ? `🚀 TURBO x${boost.multiplier}` : '⚡ BOOST ATIVO';
}

export function boostMessage(sub, boost) {
  return boost.message ? boost.message : `🎁 ${awarenessText(sub, boost)}`;
}

// Selo curto dos cartões de pacote e da barra fixa.
export function boostBadge(boost) {
  return isTurbo(boost) ? `🚀 Turbo x${boost.multiplier}` : '⚡ Boost ativo';
}

export function remainingMs(endsAt, now = Date.now()) {
  return new Date(endsAt).getTime() - now;
}

export function formatRemaining(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return hours > 0 ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}` : `${pad(minutes)}:${pad(seconds)}`;
}

// Subcampanhas com boost dentro da janela, turbo (link exclusivo) primeiro: é a
// oferta que os outros visitantes não estão vendo.
export function activeBoosts(subcampaigns, now = Date.now()) {
  return (subcampaigns || [])
    .filter((sub) => sub.active_boost && !sub.sold_out && remainingMs(sub.active_boost.ends_at, now) > 0)
    .sort((a, b) => Number(isTurbo(b.active_boost)) - Number(isTurbo(a.active_boost)));
}
